@if(progresjon().vises){
<div class="progresjon" [style.width]="progresjon().relativProgresjon"></div>
<div class="saker">
  @for(sak of progresjon().saker; track sak.sak.id){
    <span [style.width]="sak.relativBredde"
          [ngClass]="{'er-behandlet':sak.erBehandlet, 'er-ikke-behandlet':sak.erIkkeBehandlet, 'er-under-behandling':sak.erUnderBehandling, 'er-aktiv':sak.erAktivSak}"
         matTooltip="{{'start {startdato}, slutt {sluttdato}' | translate: {startdato:sak.sakstidspunkt.start|zoneddatetimeSomPlainTime|plaintime, sluttdato:sak.sakstidspunkt.slutt|zoneddatetimeSomPlainTime|plaintime} }}"
         class="sak">
      {{sak.sak.nummer}} {{sak.sak.tittel}}
    </span>
  }
  @if(progresjon().udisponertTidMinutter>0){
    <span class="udisponert" [style.width]="progresjon().udisponertTidRelativBredde" matTooltip="{{'Møtets varighet er {minutter} minutter lenger enn summen av sakenes varighet' | translate: {minutter: progresjon().udisponertTidMinutter} }}">
      {{'udisponert tid'|translate}}
    </span>
  }
</div>
}
